import Vue from 'vue';
import TaxonomySelector from '@/modules/taxonomy/selector/Selector';
import TaxonomyFormSelector from '@/modules/taxonomy/selector/FormSelector';

Vue.component(TaxonomySelector.name, TaxonomySelector);
Vue.component(TaxonomyFormSelector.name, TaxonomyFormSelector);
